import { ErrorPage } from "app/errorPage";
import {
  createBrowserRouter,
  Navigate,
  RouteObject,
  RouterProvider,
} from "react-router";
import { useRouterSettings } from "src/routerSettings";

import { ProtectedRoute } from "./components/ProtectedRoute";

export const ProtectedRouterProvider = () => {
  const routerSettings = useRouterSettings();

  const routesForAuthenticatedOnly: RouteObject[] = [
    {
      children: [
        {
          element: <Navigate replace={true} to={routerSettings.defaultRoute} />,
          index: true,
        },
        ...(routerSettings.routes.authenticatedOnly ?? []),
      ],
      element: <ProtectedRoute />,
      errorElement: <ErrorPage />,
      path: "/",
    },
  ];

  const router = createBrowserRouter([
    ...(routerSettings.routes.public ?? []),
    ...routesForAuthenticatedOnly,
  ]);
  return <RouterProvider router={router} />;
};
